import {
  addObj,
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
} from '@/api/vehiclebrandserv'

export default {
  state: {
    state_VehicleBrand_AddObjResult: null,
    state_VehicleBrand_GetAllResult: null,
    state_VehicleBrand_SearchByNameResult: null,
    state_VehicleBrand_GetPageResult: null,
    state_VehicleBrand_GetDetailResult: null,
    state_VehicleBrand_ModifyObjResult: null,
    state_VehicleBrand_DeleteObjResult: null,
  },
  mutations: {
    SET_VEHICLEBRAND_ADDOBJ_RESULT: (state, rst) => {
      state.state_VehicleBrand_AddObjResult = rst;
    },
    SET_VEHICLEBRAND_GETALL_RESULT: (state, rst) => {
      state.state_VehicleBrand_GetAllResult = rst;
    },
    SET_VEHICLEBRAND_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_VehicleBrand_SearchByNameResult = rst;
    },
    SET_VEHICLEBRAND_GETPAGE_RESULT: (state, rst) => {
      state.state_VehicleBrand_GetPageResult = rst;
    },
    SET_VEHICLEBRAND_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehicleBrand_GetDetailResult = rst;
    },
    SET_VEHICLEBRAND_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_VehicleBrand_ModifyObjResult = rst;
    },
    SET_VEHICLEBRAND_DELETEOBJ_RESULT: (state, rst) => {
      state.state_VehicleBrand_DeleteObjResult = rst;
    },
  },
  actions: {
    VehicleBrandServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEBRAND_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEBRAND_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleBrandServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEBRAND_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEBRAND_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleBrandServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEBRAND_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEBRAND_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleBrandServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEBRAND_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEBRAND_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleBrandServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEBRAND_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEBRAND_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleBrandServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEBRAND_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEBRAND_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleBrandServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEBRAND_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEBRAND_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_VehicleBrand_AddObjResult: state => {
      return state.state_VehicleBrand_AddObjResult;
    },
    get_VehicleBrand_GetAllResult: state => {
      return state.state_VehicleBrand_GetAllResult;
    },
    get_VehicleBrand_SearchByNameResult: state => {
      return state.state_VehicleBrand_SearchByNameResult;
    },
    get_VehicleBrand_GetPageResult: state => {
      return state.state_VehicleBrand_GetPageResult;
    },
    get_VehicleBrand_GetDetailResult: state => {
      return state.state_VehicleBrand_GetDetailResult;
    },
    get_VehicleBrand_ModifyObjResult: state => {
      return state.state_VehicleBrand_ModifyObjResult;
    },
    get_VehicleBrand_DeleteObjResult: state => {
      return state.state_VehicleBrand_DeleteObjResult;
    },
  }
}